import React, { useContext, useEffect } from "react";
import { AiFillHtml5 } from "react-icons/ai";
import { IoLogoCss3 } from "react-icons/io";
import { TbBrandJavascript } from "react-icons/tb";
import { GrReactjs } from "react-icons/gr";
import { FaJava, FaNodeJs } from "react-icons/fa";
import { SiExpress, SiTailwindcss } from "react-icons/si";

import "./skills.css";
import { ModeContext } from "../utils/modes-context";

const Skills = () => {
  useEffect(() => {
    const oberser = new IntersectionObserver((entries) => {
      // console.log(entries)
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });
    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => oberser.observe(el));
  }, []);

  const { darkMode } = useContext(ModeContext);

  return (
    <section className="skills" id="skills">
      <h1
        className={
          darkMode ? "sub_heading" : "sub_heading sub_heading_lightmode"
        }>
        Skills<span></span>
      </h1>
      <div className={darkMode ? "all_icons" : "all_icons all_icons_lightmode"}>
        <div className="icon_div hidden" key="html">
          <AiFillHtml5 className="icon html" />
          <h3>HTML</h3>
        </div>
        <div className="icon_div hidden" key="css">
          <IoLogoCss3 className="icon css" />
          <h3>CSS</h3>
        </div>
        <div className="icon_div hidden" key="js">
          <TbBrandJavascript className="icon js" />
          <h3>JavaScript</h3>
        </div>
        <div className="icon_div hidden" key="react">
          <GrReactjs className="icon react" />
          <h3>ReactJs</h3>
        </div>
        {/* <div className="icon_div hidden" key="java">
          <FaJava className="icon java" />
          <h3>
            Java<span>(Core)</span>
          </h3>
        </div>
        <div className="icon_div hidden" key="nodejs">
          <FaNodeJs className="icon nodejs" />
          <h3>
            NodeJs<span>(Learning)</span>
          </h3>
        </div>
        <div className="icon_div hidden" key="express">
          <SiExpress className="icon express" />
          <h3>
            ExpressJs<span>(Learning)</span>
          </h3>
        </div> */}
        <div className="icon_div hidden" key="tailwind">
          <SiTailwindcss className="icon tailwind" />
          <h3>tailwindcss</h3>
        </div>
      </div>
    </section>
  );
};

export default Skills;
